/* eslint-disable camelcase */
import { Button, CheckboxInput } from "@rocketmakers/armstrong";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { CTMeterIem3100, CTMeter_SCHNEIDER_IEM3455 } from "../../../../shared/api-clients/_api";
import { useRoutePaths } from "../../../../shared/context/paths";
import { BackButton } from "../../components/buttons/back-button";
import { routePaths } from "../../routes";

export const configurationChecks = [
	"Confirm the meter is set to MODBUS address 6",
	"Confirm HOBUT 120A CT clamps are being used",
];

export interface CTMeterBaseConfiguration extends CTMeterIem3100 {
	editMode?: boolean;
}

export const ConfigureCTMeterView: React.FunctionComponent = () => {
	const { push } = useRoutePaths();
	const { location } = useHistory<CTMeter_SCHNEIDER_IEM3455>();

	const handleContinue = () => {
		push<CTMeterBaseConfiguration>(routePaths.currentTransformerMeters.clamp, {}, location.state);
	};

	const [checklist, updateChecklist] = React.useState(configurationChecks.map(() => false));

	const hasCompletedChecks = checklist.every((value) => value === true);

	return (
		<div>
			<BackButton />
			<h1>
				CT Meter <span className="color-primary">configuration</span>
			</h1>

			<div>
				{configurationChecks.map((message, idx) => (
					<CheckboxInput
						// rome-ignore lint/suspicious/noArrayIndexKey: <explanation>
						key={idx}
						labelContent={message}
						checked={checklist[idx]}
						data-qa={`ct-meter-check-${idx}`}
						onChange={(e) => updateChecklist(checklist.map((value, i) => (idx === i ? e.target.checked : value)))}
					/>
				))}
			</div>

			<div className="row">
				<Button
					className="continue-button btn-full btn-large"
					disabled={!hasCompletedChecks}
					onClick={handleContinue}
					data-qa="continue-button"
				>
					Continue
				</Button>
			</div>
		</div>
	);
};
